import { useGetLoggedInUserQuery } from '../redux/api/users';

/**
 * Groups allowed to view/edit revenue. Mirrors the backend
 * REVENUE_ACCESS_GROUPS setting (default "Shop Managers,Shop Manager") and
 * reuses the same Shop Managers role that gates /admin/settings.
 */
const REVENUE_ACCESS_GROUPS = ['Shop Managers', 'Shop Manager'];

/**
 * Returns whether the logged-in user may view revenue (and, since we reuse a
 * single role, edit it too). Superusers always can. Fails closed while the
 * user is still loading. Revenue is sensitive financial data that must stay
 * hidden from overseas programmers and other non-authorized roles.
 */
export const useCanViewRevenue = (): boolean => {
	const { data: user } = useGetLoggedInUserQuery();

	if (!user) {
		return false;
	}

	if (user.is_superuser) {
		return true;
	}

	return (user.groups || []).some((group) =>
		REVENUE_ACCESS_GROUPS.includes(group)
	);
};

export default useCanViewRevenue;
